import Vue from 'vue'
import VueRouter from 'vue-router'

import i18n from '../resources/i18n.js'

import Home from '../views/Home.vue'
import RubinAbout from '../views/RubinAbout.vue'
import Career from '../views/Career.vue'
import ItSolutions from '../views/ItSolutions.vue'
import EnergyManagement from '../views/EnergyManagement.vue'

import SubMetering from '../views/EnergyManagement/SubMetering.vue'
import Rubicon from '../views/EnergyManagement/Rubicon.vue'
import EnergyMonitor from '../views/EnergyManagement/EnergyMonitor.vue'
import Tempering from '../views/EnergyManagement/Tempering.vue'
import InvoiceMonitor from '../views/EnergyManagement/InvoiceMonitor.vue'
import Tao from '../views/EnergyManagement/Tao.vue'
import Hardware from '../views/Hardware.vue'

import InstallationManager from '../views/OpenPositions/InstallationManager.vue'
// import SystemAndWorkflowOperationSupportStaffMember from '../views/OpenPositions/SystemAndWorkflowOperationSupportStaffMember.vue'

// import Articles from '../views/Articles.vue'
// import Article from '../views/Article.vue'
// import Design from '../views/Design.vue'

import NotFound from '../views/NotFound.vue'


Vue.use(VueRouter)

  const routes = [
    {
      path: '/kezdokepernyo',
      name: 'Home',
      component: Home
    },
    {
      path: '/rolunk',
      name: 'RubinAbout',
      component: RubinAbout
    },
    {
      path: '/karrier',
      name: 'Career',
      component: Career
    },
    {
      path: '/it-megoldasok',
      name: 'ItSolutions',
      component: ItSolutions
    },
    {
      path: '/energia-menedzsment',
      name: 'EnergyManagement',
      component: EnergyManagement
    },
    {
      path: '/almerosites',
      name: 'SubMetering',
      component: SubMetering
    },
    {
      path: '/rubicon',
      name: 'Rubicon',
      component: Rubicon
    },
    {
      path: '/energia-monitor',
      name: 'EnergyMonitor',
      component: EnergyMonitor
    },
    {
      path: '/szerverterem-temperalas',
      name: 'Tempering',
      component: Tempering
    },
    {
      path: '/szamla-monitor',
      name: 'InvoiceMonitor',
      component: InvoiceMonitor
    },
    {
      path: '/tao-csokkentes',
      name: 'Tao',
      component: Tao
    },
    {
      path: '/hardver',
      name: 'Hardware',
      component: Hardware
    },
    {
      path:'/karrier-telepites-vezeto',
      name: 'InstallationManager',
      component: InstallationManager
    },
    // {
    //   path:'/karrier-uzemeltetes-tamogatasi-munkatars',
    //   name: 'SystemAndWorkflowOperationSupportStaffMember',
    //   component: SystemAndWorkflowOperationSupportStaffMember
    // },

    // {
    //   path: '/Articles',
    //   name: 'Articles',
    //   component: Articles
    // },
    // {
    //   path: '/Article',
    //   name: 'Article',
    //   component: Article
    // },
    // {
    //   path: '/Design',
    //   name: 'Design',
    //   component: Design
    // },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    },
  ]

  const router = new VueRouter({
    mode: 'history',
    routes
  })

  router.beforeEach((to, from, next) => {
    var realPaths = router.options.routes.map(el => el.path);
    if (!realPaths.includes(to.path)) {
      if (to.path == '/') {
        next('/kezdokepernyo');
      } else {
        next();
      }
    } else {
      next();
    }
  });

export default router
